import React, { useState, useEffect } from "react";
import PinModal from "../../components/Modal/Pin/PinModal";
import { NotificationManager } from "react-notifications";
import { hideLoader, showLoader } from "../../utils/loader";
import { customBaseUrl, httpDelete, httpGet, httpPost } from "../../store/http";
import { useNavigate } from "react-router-dom";
import AntDropdown from "../../components/CustomDropdown/AntDropdown";
import slugs from "../../resources/slugs";
import AntTable from "../../components/CustomTable/AntTable";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Grid as MatGrid, Paper } from "@mui/material";
import { useMatStyles } from "../users/ManageRefferal/style";
import { Button, Modal, Row, Checkbox, Form, Input } from "antd";
import Layout from "../../components/Layout";




const LoanAdmins = ({ setShowProfile }) => {
  // const roles= localStorage.getItem('roles')
  const styles = useMatStyles();
  let navigate = useNavigate();
  const [isAdmin, setIsadmin] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [otp, setOtp] = useState('')
  const [admins, setAdmins] = useState([]);
  const [roles, setRoles] = useState([]);
  const [user, setUser] = useState([]);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showAssignRoleModal, setShowAssignRoleModal] = useState(false);
  const [showRevokeRoleModal, setShowRevokeRoleModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 10,
  });

  const handleGetAdmins = async () => {
    const res = await httpGet(
      `${customBaseUrl.loanUrl}/api/v1/admin`
    );
    if (res.status = true) {
      setAdmins(res.data)
    }
  }

  const handleGetRoles = async () => {
    const res = await httpGet(
      `${customBaseUrl.loanUrl}/api/v1/roles`
    );
    if (res.status = true) {
      setRoles(res.data)
    }
  }

  const handleAdd = async (e) => {
    e.preventDefault();
    const pData =
    {
      email: user.email,
      // password: user.password,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      roles: user.roles,
    }

    showLoader();
    const res = await httpPost(
      `${customBaseUrl.loanUrl}/api/v1/admin/create-approver`,
      pData
    );
    if (res.status) {
      NotificationManager.success(res.message);
      hideLoader();
      handleGetAdmins();
      setShowAdmin(false);

    } else {
      hideLoader();
      NotificationManager.error(res.message);
    }
  }
  const deleteAdmin = async (val) => {
    showLoader();
    const res = await httpDelete(
      `${customBaseUrl.loanUrl}/api/v1/admin/approver/${val.id}`,
      {}
    );
    if (res.status) {
      NotificationManager.success(res.message);
      hideLoader();
      handleGetAdmins();
    } else {
      hideLoader();
      NotificationManager.error(res.message);
    }
  };
  const [showRegeneratePasswordModal, setShowRegeneratePasswordModal] = useState(false);

  const handleRegeneratePassword = async (values) => {
    showLoader();
    const pData = {
      adminId: selectedAdmin.id,
    };
    const res = await httpPost(
      `${customBaseUrl.loanUrl}/api/v1/admin/regenerate-password`,
      pData
    );
    if (res.status) {
      NotificationManager.success(res.message);
      hideLoader();
      setShowRegeneratePasswordModal(false);
    } else {
      hideLoader();
      NotificationManager.error(res.message);
    }
  };

  const handleDropdownAction = (item, data) => {
    setSelectedAdmin(data);
    if (item === "Delete") deleteAdmin(data);
    if (item === "Assign Role") setShowAssignRoleModal(true);
    if (item === "Revoke Role") setShowRevokeRoleModal(true);
    if (item === "Regenerate Password") setShowRegeneratePasswordModal(true);
    if (item === "View Logs") navigate(slugs.loan_audit_logs, { state: { actorId: data.email } });
  };

  const handleAssignRole = async (values) => {
    showLoader();
    const pData = {
      userId: selectedAdmin.id,
      roleName: values.roleName,
      notes: values.notes,
    };
    const res = await httpPost(
      `${customBaseUrl.loanUrl}/api/v1/roles/assign`,
      pData
    );
    if (res.status) {
      NotificationManager.success(res.message);
      hideLoader();
      handleGetAdmins();
      setShowAssignRoleModal(false);
    } else {
      hideLoader();
      NotificationManager.error(res.message);
    }
  };

  const handleRevokeRole = async (values) => {
    showLoader();
    const res = await httpDelete(
      `${customBaseUrl.loanUrl}/api/v1/roles/revoke/${selectedAdmin.id}/${values.roleName}`,
      {}
    );
    if (res.status) {
      NotificationManager.success(res.message);
      hideLoader();
      handleGetAdmins();
      setShowRevokeRoleModal(false);
    } else {
      hideLoader();
      NotificationManager.error(res.message);
    }
  };

  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const handleOtp = async () => {
    if (otp === "") {
      return NotificationManager.error("OTP is required");
    }
    showLoader();
    const res = await httpGet(
      `${customBaseUrl.loanUrl}/api/v1/admin/verify-otp/owner?otp=${Number(otp)}`
    );
    if (res.status) {
      NotificationManager.success("OTP verified successfully");
      hideLoader();
      setIsOtpVerified(true);
      setIsModalVisible(false);
    } else {
      hideLoader();
      NotificationManager.error(res.message);
    }
  }

  const sendOTP = async () => {
    showLoader();
    const res = await httpPost(
      `${customBaseUrl.loanUrl}/api/v1/admin/send-otp/owner`,
      {
        email: localStorage.getItem('email')
      }
    );
    if (res.status === true) {
      NotificationManager.success("OTP sent");
      hideLoader();
      setIsModalVisible(true);
    } else {
      hideLoader();
      NotificationManager.error("Failed to send OTP");
      navigate(-1);
      // setIsModalVisible(true);
      NotificationManager.error(res.message);
    }
  }

  useEffect(() => {
    if (isOtpVerified) {
      handleGetAdmins();
      handleGetRoles();
    }
  }, [isOtpVerified])

  useEffect(() => {
    const roles = localStorage.getItem('roles')
    if (roles?.includes('ROLE_OWNER') !== -1 || roles?.includes('ROLE_SUPER') !== -1) {
      sendOTP()
    }
  }, [])

  const columns = [

    {
      field: 'first_name',
      headerName: 'First Name',
      width: 200,
      headerClassName: styles.tableHeader,

    },
    {
      field: 'last_name',
      headerName: 'Last Name',
      width: 200,
      headerClassName: styles.tableHeader,


    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200,
      headerClassName: styles.tableHeader,


    },
    {
      field: 'roles',
      headerName: 'Roles',
      width: 200,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => <span>{row.roles.join(', ')}</span>
    },
    {
      field: 'id',
      headerName: 'Action',
      width: 200,
      headerClassName: styles.tableHeader,
      renderCell: ({ row }) => <AntDropdown
        dropDownOptions={[
          "Delete",
          "Assign Role",
          "Revoke Role",
          "Regenerate Password",
          "View Logs",
        ]}
        handleDropdownAction={(item) =>
          handleDropdownAction(item, row)
        }
        // userId={id}
        isArrow
      />
    },
  ];

  return (
    <Layout >
      {isOtpVerified ? <div>
        <Modal
          // className={className}
          title="Add Approver"
          centered
          visible={showAdmin}
          onOk={() => setShowAdmin(false)}
          onCancel={() => setShowAdmin(false)}
          width={500}
          footer={0}
        >
          {/* <Divider>
        <div style={{ marginBottom: "20px" }}>
          <Typography>Page: {page}</Typography>
        </div>
      </Divider> */}
          <form class="row g-3 needs-validation" onSubmit={handleAdd} >

            <div class="col-md-12">
              <label for="validationCustom01" class="form-label">
                First Name
              </label>
              <input
                type="text"
                class="form-control"
                id="validationCustom01"
                value={user.firstName}
                required
                onChange={(e) =>
                  setUser({ ...user, firstName: e.target.value })
                }
              />
            </div>

            <div class="col-md-12">
              <label for="validationCustom02" class="form-label">
                Last Name
              </label>
              <input
                type="text"
                class="form-control"
                id="validationCustom02"
                value={user.lastName}
                required
                onChange={(e) =>
                  setUser({ ...user, lastName: e.target.value })
                }
              />
            </div>

            <div class="col-md-12">
              <label for="validationCustom03" class="form-label">
                Email
              </label>
              <input
                type="email"
                class="form-control"
                id="validationCustom03"
                value={user.email}
                required
                onChange={(e) =>
                  setUser({ ...user, email: e.target.value })
                }
              />
            </div>

            <div class="col-md-12">
              <label for="validationCustom04" class="form-label">
                Phone
              </label>
              <input
                type="text"
                class="form-control"
                id="validationCustom04"
                value={user.phone}
                required
                onChange={(e) =>
                  setUser({ ...user, phone: e.target.value })
                }
              />
            </div>

            {/* <div class="col-md-12">
                <label for="validationCustom05" class="form-label">
                  Password
                </label>
                <input
                  type="password"
                  class="form-control"
                  id="validationCustom05"
                  value={user.password}
                  required
                  onChange={(e) =>
                    setUser({ ...user, password: e.target.value })
                  }
                />
              </div> */}

            <div class="col-md-12">
              <label for="validationCustom06" class="form-label">
                Role type
              </label>
              <Checkbox.Group
                options={roles?.filter(e => e.name !== 'user')?.map(role => ({ label: role.name, value: role.name }))}
                value={user?.roles}
                onChange={(checkedValues) =>
                  setUser({ ...user, roles: checkedValues })
                }
              />
              <div class="invalid-feedback">Role is required.</div>
            </div>

            <button className="btn" style={{ background: '#ff6700' }} type="submit">Add</button>
          </form>
        </Modal>
        <div>
          <Row type="flex" justify="end" align="middle">
            <Button
              size="medium"
              style={{ background: "black", fontSize: "10px", color: "#fff" }}
              onClick={() => setShowAdmin(true)}
            >
              Add Approver
            </Button>
          </Row>
        </div>
        <MatGrid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={styles.matGrid}
        >

          <div style={{ height: 800, width: "100%" }}>
            <DataGrid

              density="comfortable"
              rows={admins}
              columns={columns}
              page={pagination.current}
              // paginationMode="server"
              pageSize={pagination.pageSize}
              // onPageSizeChange={(newPageSize) =>
              //   handleChangeRowsPerPage(newPageSize)
              // }
              // onPageChange={(newPage) => handleChangePage(newPage)}
              rowsPerPageOptions={[5, 10, 20, 50, 100]}
              pagination
              components={{ Toolbar: GridToolbar }}
              rowCount={admins.length}

            />
          </div>
        </MatGrid>
        {isModalVisible && <PinModal

          showModal={isModalVisible}
          hideModal={setIsModalVisible}
          otp={otp}
          setOtp={setOtp}
          numInputs={6}
          separator=''
          buttonLabel='Verify'
          title='Verify OTP'
          description='Please input the OTP sent to your Phone'
          pinMode={true}

        />}

        <Modal
          title="Assign Role"
          visible={showAssignRoleModal}
          onCancel={() => setShowAssignRoleModal(false)}
          footer={null}
        >
          <Form onFinish={handleAssignRole} layout="vertical">
            <Form.Item
              label="Role Name"
              name="roleName"
              rules={[{ required: true, message: "Please select a role!" }]}
            >
              <select
                class="form-select"
                id="assignRole"
                required
              >
                <option value="">Select Role</option>
                {roles.length > 0 && roles?.map(role => (
                  <option key={role.id} value={role.name}>
                    {role.name}
                  </option>
                ))}
              </select>
            </Form.Item>
            <Form.Item label="Notes" name="notes">
              <Input.TextArea rows={4} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Assign Role
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title="Revoke Role"
          visible={showRevokeRoleModal}
          onCancel={() => setShowRevokeRoleModal(false)}
          footer={null}
        >
          <Form onFinish={handleRevokeRole} layout="vertical">
            <Form.Item
              label="Role Name"
              name="roleName"
              rules={[{ required: true, message: "Please select a role to revoke!" }]}
            >
              <select
                class="form-select"
                id="revokeRole"
                required
              >
                <option value="">Select Role</option>
                {selectedAdmin?.roles?.map(role => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Revoke Role
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title="Regenerate Password"
          visible={showRegeneratePasswordModal}
          onCancel={() => setShowRegeneratePasswordModal(false)}
          footer={null}
        >
          <Form onFinish={handleRegeneratePassword} layout="vertical">
            <p>Are you sure you want to regenerate the password for {selectedAdmin?.email}?</p>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Regenerate Password
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
        : <PinModal

          showModal={isModalVisible}
          hideModal={setIsModalVisible}
          otp={otp}
          setOtp={setOtp}
          numInputs={6}
          separator=''
          buttonLabel='Verify'
          title='Verify OTP'
          description='Please input the OTP sent to your Phone'
          pinMode={true}
          handleSubmit={handleOtp}

        />}
    </Layout>
  )
}

export default LoanAdmins;

